import { render, staticRenderFns } from "./EkpTabPage.vue?vue&type=template&id=684280b2"
import script from "./ekpTabPage.js?vue&type=script&lang=js&external"
export * from "./ekpTabPage.js?vue&type=script&lang=js&external"
import style0 from "./EkpTabPage.vue?vue&type=style&index=0&id=684280b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports